"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/stable");
require("regenerator-runtime/runtime");
var _index = _interopRequireDefault(require("./connectClient/index"));
var _index2 = _interopRequireDefault(require("./connectProvider/index"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// INITIATOR CLIENT
// The initiator client is the integration end of the connection,
// and sends the connection details to
// the signal server which then waits for a corresponding receiver connection.
// CRYPTO
// the crypto constructor is a collection of methods used by both the initiator and receiver
// in creating the direct connection
// import icons from './icon';
var _default = exports.default = {
  Initiator: _index.default.Initiator,
  Crypto: _index.default.Crypto,
  Client: _index.default,
  Provider: _index2.default
  // icons
};